"use client";

export { BrowserErrorCapture, ErrorFallback, type ErrorCopy, type ErrorFallbackProps } from "./error-fallback";
export { reportBrowserError } from "./reporter";
